import { render } from "./HeaderDocument.vue?vue&type=template&id=161bd9b8&scoped=true"
import script from "./HeaderDocument.vue?vue&type=script&lang=js"
export * from "./HeaderDocument.vue?vue&type=script&lang=js"

import "./HeaderDocument.vue?vue&type=style&index=0&id=161bd9b8&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\Tomi\\PhpstormProjects\\frontend-v2\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-161bd9b8"]])

export default __exports__